import { render, staticRenderFns } from "./PageTransfer.vue?vue&type=template&id=f613dca6&"
import script from "./PageTransfer.vue?vue&type=script&lang=js&"
export * from "./PageTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/bluehost-site-migrator/bluehost-site-migrator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f613dca6')) {
      api.createRecord('f613dca6', component.options)
    } else {
      api.reload('f613dca6', component.options)
    }
    module.hot.accept("./PageTransfer.vue?vue&type=template&id=f613dca6&", function () {
      api.rerender('f613dca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/components/PageTransfer.vue"
export default component.exports